import React from "react";
import "./Text.scss"
const HeaderText = ({ text, invert = false }) => {
    return (
        <div className={!invert ? "HeaderText-Rewardstick" : "HeaderText-Rewardstick-invert"}>{text}</div>
    )
}
export default HeaderText